<template lang="pug">
md-layout#thumbnails(md-flex='100', v-if='mediaItem.poster && mediaItem.thumbnails')
    .md-headline Thumbnail
    md-layout(md-flex='100')
      div.thumbnailContainer(v-show='thumbnailView === "autogenerated"', key='autogeneratedView')
        div(v-for='(poster) in getThumbnails()')
          img.thumbnail(:src="poster.startsWith('http') ? poster : '//' + imageServerBase + '/' + poster",
            v-bind:class="{'selected': mediaItem.poster.desktop === poster}",
            v-on:click="changePoster($event, poster)",
            v-if='!poster.match("uploaded")')
</template>

<script>


export default {
  props: ['mediaItem'],
  components: { },
  data() {
    return {
      imageServerBase: process.env.THUMBNAIL_BASE_URL,
      thumbnailView: 'autogenerated',
    };
  },
  methods: {
    changePoster(event, poster) {

      if (event.target.classList.contains('selected')) {
        return;
      }

      if (!event.target.classList.contains('changed')) {
        event.target.parentNode.parentNode.childNodes.forEach((el, idx, array) => {
          if (!idx === array.length - 1) el.firstChild.classList.remove('changed')
        });
      }

      event.target.classList.toggle('changed');
      this.$emit('deleteCustom', poster);
      this.$emit('update', poster);
    },

    openAddThumbnail() {
      this.$emit('openAddThumbnail');
    },

    thumbnailUploaded(url) {
      this.$emit('update', url);
    },

    getThumbnails() {
      const desktopThumbnails = this.mediaItem.thumbnails.desktop;
      const defaultThumbnails = this.mediaItem.thumbnails.default;

      return desktopThumbnails.length > 0 ? desktopThumbnails : defaultThumbnails;
    }
  },
};
</script>

<style lang="scss" scoped>
.thumbnailContainer {
  padding: 15px;
  width: 100%;
  height: 400px;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;

}

.thumbnail {
  max-width: 200px;
  display: block;
  cursor: pointer;

  &.selected {
    box-shadow: 0 0 0 4px #4ea9dd;
    cursor: default;
  }

  &.changed {
    border: 4px solid rgba(0, 0, 0, 0.54);
  }
}
</style>



// WEBPACK FOOTER //
// src/shared-components/mediaItem/MediaItemPosterSelector.vue